export default __webpack_public_path__ + "static/terence-ccda8ade83c846856215e6edc808ea7c.jpg";